<template>
  <div class="social-share-button">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.social-share-button {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  transition: all $easing;
  :deep(*) {
    transition: all $easing;
  }

  &:hover {
    background-color: var(--primary-light);

    :deep(*) {
      color: var(--primary);
    }
  }

  > * {
    width: 24px;
    height: 24px;
  }
}
</style>
